import { styled } from 'styled-components';
import config from '../config.json';
import { theme } from '../styles';
import { Button } from '.';
import { TwitterIcon, PixivIcon, PatreonIcon } from '../assets/svg';

const footerLinks = [
  {
    icon: <TwitterIcon />,
    link: config.socialMedia.twitter.link,
  },
  {
    icon: <PixivIcon />,
    link: config.socialMedia.pixiv.link,
  },
  {
    icon: <PatreonIcon />,
    link: config.socialMedia.patreon.link,
  },
];

const Footer = () => (
  <FooterWrapper>
    {footerLinks.map((link, ind) => {
      return (
        <Button
          key={`footer-link-${ind}`}
          type='Link'
          style='fill'
          size='md'
          icon={true}
          to={link.link}
          target='blank'
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(ind === 1 ? theme.delayMd : theme.delayLg)}
        >
          {link.icon}
        </Button>
      );
    })}
  </FooterWrapper>
);

const FooterWrapper = styled.footer`
  margin: 0 auto;
  display: flex;
  gap: ${props => props.theme.spaceXl};
`;

export default Footer;
